import { ImageInput } from "@circle-react-uikit/ImageInput";
import type { ImageInputProps } from "@circle-react-uikit/ImageInput";
import { ImageLoader } from "./ImageLoader";
import { ImagePreview } from "./ImagePreview";
import { ImageUpload } from "./ImageUpload";

interface CustomThumbnailInputProps extends Omit<ImageInputProps, "renderer"> {
  description?: string;
  imageAlt?: string;
}

export const CustomThumbnailInput = ({
  name,
  title,
  description,
  imageAlt = title,
  aspectRatio = 16 / 9,
  hideUnsplash = true,
  ...rest
}: CustomThumbnailInputProps) => (
  <ImageInput
    name={name}
    title={title}
    aspectRatio={aspectRatio}
    hideUnsplash={hideUnsplash}
    renderer={({
      handleChangeCoverClick: handleChange,
      handleDelete,
      imageUrl,
      processing: isProcessing,
      value,
    }) =>
      isProcessing ? (
        <ImageLoader />
      ) : value ? (
        <ImagePreview
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          onChange={handleChange}
          onDelete={handleDelete}
        />
      ) : (
        <ImageUpload description={description} onUpload={handleChange} />
      )
    }
    {...rest}
  />
);
